import { getRequest, patchRequest } from 'apis/ApiInstence';
import React, { useEffect, useState } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';

const initialFormData = {
  mobile_number: '',
  email: '',
  address: '',
  instagram_link: '',
  facebook_link: '',
  youtube_link: '',
  whatsapp_number: '',
  map_link: '',
  status: 'active',
};

const fields = [
  { name: 'mobile_number', label: 'Mobile Number *', required: true },
  { name: 'whatsapp_number', label: 'WhatsApp Number' },
  { name: 'email', label: 'Email', type: 'email' },
  { name: 'instagram_link', label: 'Instagram Link' },
  { name: 'facebook_link', label: 'Facebook Link' },
  { name: 'youtube_link', label: 'YouTube Link' },
  { name: 'map_link', label: 'Map Link' },
];

const UpdateSiteSetup = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const [formData, setFormData] = useState(initialFormData);
  const [fetching, setFetching] = useState(true);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchRecord = async () => {
      try {
        const res = await getRequest(`sitesetup/${id}`);
        const data = res.data?.data;
        if (!data) {
          toast.error('Site setup not found');
          navigate('/sitesetup');
          return;
        }

        setFormData({
          mobile_number:   data.mobile_number || '',
          email:           data.email || '',
          address:         data.address || '',
          instagram_link:  data.instagram_link || '',
          facebook_link:   data.facebook_link || '',
          youtube_link:    data.youtube_link || '',
          whatsapp_number: data.whatsapp_number || '',
          map_link:        data.map_link || '',
          status:          data.status || 'active',
        });
      } catch (error) {
        toast.error(error?.response?.data?.message || 'Failed to load site setup');
        navigate('/sitesetup');
      } finally {
        setFetching(false);
      }
    };

    fetchRecord();
  }, [id, navigate]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.mobile_number.trim()) {
      toast.error('Mobile number is required');
      return;
    }

    setLoading(true);
    try {
      await patchRequest(`sitesetup/${id}`, formData);
      toast.success('Site setup updated successfully');
      navigate('/sitesetup');
    } catch (error) {
      toast.error(error?.response?.data?.message || error?.message || 'Failed to update site setup');
    } finally {
      setLoading(false);
    }
  };

  if (fetching) return <div className="text-center mt-5">Fetching site setup...</div>;

  return (
    <div className="container-fluid mt-5">
      <div className="mainheadig mx-4">
        <h4 className="font-weight-bold">Update Site Setup</h4>
      </div>

      <form onSubmit={handleSubmit} className="form-style">
        <div className="row mx-4 mt-4">
          {fields.map((field) => (
            <div className="col-sm-6 mt-3" key={field.name}>
              <label htmlFor={field.name} className="lables">{field.label}</label>
              <input
                id={field.name}
                name={field.name}
                type={field.type || 'text'}
                className="form-control"
                value={formData[field.name]}
                onChange={handleChange}
                required={field.required}
              />
            </div>
          ))}

          <div className="col-sm-6 mt-3">
            <label htmlFor="status" className="lables">Status</label>
            <select id="status" name="status" className="form-control" value={formData.status} onChange={handleChange}>
              <option value="active">Active</option>
              <option value="inactive">Inactive</option>
            </select>
          </div>

          <div className="col-sm-12 mt-3">
            <label htmlFor="address" className="lables">Address</label>
            <textarea
              id="address"
              name="address"
              className="form-control"
              rows="3"
              value={formData.address}
              onChange={handleChange}
              placeholder="Full site address..."
            />
          </div>
        </div>

        <div className="mt-5 text-right mx-4">
          <button type="submit" className="btn btn-lg addbtn" disabled={loading}>
            {loading ? 'Updating...' : 'Update Site Setup'}
          </button>
        </div>
      </form>
    </div>
  );
};

export default UpdateSiteSetup;
